<div class="page-title-area item-bg-6">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Collaboration and Project Management</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Collaboration and Project Management</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-video">
            <div class="details-image">
                <!-- Puedes agregar una imagen principal aquí si deseas -->
            </div>
            <div class="details-video">
                <!-- Video relacionado con la colaboración y gestión de proyectos -->
            </div>
            <div class="text">
                <h3>Streamline Collaboration and Boost Productivity</h3>
                <p>
                    I specialize in fostering effective collaboration and project management across teams to ensure timely delivery and high-quality results:
                    <br><br>
                    • <strong>Task Management with Jira:</strong> I use Jira to organize tasks, prioritize work, and track progress across projects.<br>
                    • <strong>Team Collaboration Tools:</strong> I implement tools like Slack, Zoom, and Microsoft Teams to improve communication and collaboration.<br>
                    • <strong>Agile Methodology:</strong> I apply Agile principles to ensure flexibility, efficiency, and continuous improvement.<br>
                    • <strong>Documentation and Knowledge Sharing:</strong> I facilitate easy access to project documentation, designs, and technical specifications.<br>
                    • <strong>Project Monitoring and Reporting:</strong> I set up monitoring tools and generate reports to track project health and progress.
                </p>
            </div>
        </div>
         <div class="bar"></div>
        <div class="services-details-overview">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-desc">
                        <h3>Efficient Team Collaboration and Project Execution</h3>
                        <p>
                            I ensure that teams are aligned, communication is clear, and projects are delivered on time and within scope:
                            <br><br>
                            <strong>My expertise includes:</strong><br>
                            • Implementing Agile and Scrum methodologies<br>
                            • Using collaboration tools like Slack, Trello, and Zoom<br>
                            • Facilitating daily standups and sprint planning<br>
                            • Setting up task tracking and reporting systems<br>
                            • Documenting and sharing project-related knowledge effectively
                        </p>
                        <div class="features-text">
                            <h4>Why Work With Me?</h4>
                            <p>
                                • <strong>Experienced in Agile:</strong> I bring deep experience in Agile and Scrum practices for managing projects.<br>
                                • <strong>Team Coordination:</strong> I ensure teams work together seamlessly and are motivated towards common goals.<br>
                                • <strong>Efficient Task Management:</strong> I prioritize tasks and ensure deadlines are met through effective tracking.<br>
                                • <strong>Comprehensive Communication:</strong> I implement systems for clear and continuous communication between stakeholders.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-image">
                        <img src="assets/img/services-details/resenia.png" alt="Collaboration Image">
                    </div>
                </div>
            </div>
        </div>

        <div class="services-details-overview">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-image">
                        <img src="assets/img/services-details/teamwork.webp" alt="Project Management Image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>